import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=0cb4caf5"
import script from "./PrintPage.vue?vue&type=script&lang=js"
export * from "./PrintPage.vue?vue&type=script&lang=js"
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=0cb4caf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports